// 该文件由 vite-plugin-version-generator 自动生成
// 不要手动编辑此文件，它会在每次构建时自动生成

export const VERSION_INFO = {
  "version": "23.4",
  "major": 23,
  "minor": 4,
  "timestamp": 1793842997838,
  "buildTime": "2026-11-05 09:43:17"
} as const;

export const APP_VERSION = VERSION_INFO.version;
export const BUILD_TIME = VERSION_INFO.buildTime;
export const BUILD_TIMESTAMP = VERSION_INFO.timestamp;
